import { Organization, User } from '@rematter/frontend-lib-api-client';
import { atomWithStorage } from 'jotai/utils';

export const $accessToken = atomWithStorage<string | null>(
  'authentication.accessToken',
  null,
  undefined,
  { getOnInit: true },
);

export const $organization = atomWithStorage<Organization | null>(
  'authentication.organization',
  null,
  undefined,
  { getOnInit: true },
);

export const $user = atomWithStorage<User | null>(
  'authentication.user',
  null,
  undefined,
  { getOnInit: true },
);

export type Impersonation = {
  email: string;
  reason?: string;
};

export const $impersonator = atomWithStorage<Impersonation | null>(
  'authentication.impersonator',
  null,
  undefined,
  { getOnInit: true },
);

export const $facilityId = atomWithStorage<string | null>(
  'identity.facilityId',
  null,
  undefined,
  { getOnInit: true },
);
